var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.8c4775faad65fb863f242f900a79fe7b.svg#l';
                    var viewUrl = 'sprites.8c4775faad65fb863f242f900a79fe7b.svg#view-l';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 18',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };